export {BaseData} from "./data";

export {BaseDocument} from "./document";
export {BaseQuery} from "./query";
export {BaseCollection} from "./collection";

export {Gettable, GettablePlural} from "./gettable";


